import type { MeProfileKpiTargetUnit } from "@/modules/users/domain/employee-profile.types";

/**
 * ຈັດຮູບຄ່າເປົ້າ/ຜົນຈິງຕາມ `targetUnit` (ສອດຄ່ອງກັບໜ້າ KPI ລາຍລະອຽດ)
 */
export function formatKpiProfileMetric(
  value: number | null,
  targetUnit: MeProfileKpiTargetUnit,
): string {
  if (value == null) return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  const s = n.toLocaleString("lo-LA", { maximumFractionDigits: 2 });

  switch (targetUnit) {
    case "currency":
      return `${s} ກີບ`;
    case "percent":
      return `${s}%`;
    case "count":
      return `${s} ຄັ້ງ`;
    case "score":
      return `${s} ຄະແນນ`;
    case "none":
    default:
      return s;
  }
}
